import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { NewMeasurementPointPhotoModel } from '../../models/rope-shovel.model';
import { RopeShovelService } from '../../rope-shovel.service';

@Component({
  selector: 'app-additional-record-image',
  templateUrl: './additional-record-image.component.html',
  styleUrls: ['./additional-record-image.component.scss']
})
export class AdditionalRecordImageComponent implements OnInit {
  @Input() recordId: number = 0;
  @Output() onPhotoUpload: EventEmitter<any> = new EventEmitter();
  photo: string = '';
  photoLoading = false;

  @Input() id: number = 0;
  @Input() side: string = "";
  @Input() inspectionId: number = 0;
  @Input() type: number =0;
  reading:string=null;
  

  constructor(private _service: RopeShovelService,
    private _notify: NotificationsService) { }
  ngOnInit() {
  }
  
  onSelectPhoto(event) {
    this.photoLoading =true;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => { // called once readAsDataURL is completed
        this.photo = event.target["result"].toString();
        //this.uploadNewAdditionalRecordPhoto(this.photo);


        //this.newPhoto = event.target.result;

        //resize photo
        this.compressImage(this.photo).then((res: string) => {
          if (res) {
            this.uploadNewAdditionalRecordPhoto(res);
          }
        })
      }
    }
  }
  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');

        let width, height;
        width = img.width;
        height = img.height;

        console.log('width', width)
        console.log('height', height)

        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height


        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }
  uploadNewAdditionalRecordPhoto(p: string) {
  //  this._notify.info('Uploading', 'Uploading your photo now...');
      let uploadModel = new NewMeasurementPointPhotoModel(this.recordId, 0, p.split(",")[1]);
    if(this.recordId==-1){
      this.updateRecord(uploadModel);
      this.onPhotoUpload.emit(null);
      this.photoLoading =false;
      
    }else{
      
      this._service.uploadNewAdditionalRecordPhoto(uploadModel).subscribe(r => {
        if (r.m_Item1) {
          this._notify.success('Uploaded', r.m_Item2);
          this.onPhotoUpload.emit(null);
          this.photoLoading =false;
        } else {
          this._notify.error('Failed', r.m_Item2);
          console.log(r);
        }
      }, err => {
        this._notify.error('Failed', 'Unable to upload photo. Please contact TrackTreads support. ');
        console.log(err);
        this.photoLoading = false;
      });
    }
   
  }

  

  updateRecord(photomodel:NewMeasurementPointPhotoModel) {
    if(this.type==1){
      this.reading = "-1";
    }else {
      this.reading =null;
    }
    this._service.updateAdditionalRecord(this.recordId, this.id, this.side, this.inspectionId, this.reading).subscribe(r => {
      if (r.m_Item1>0) {
        photomodel.InspectionDetailId = r.m_Item1;
        this._service.uploadNewAdditionalRecordPhoto(photomodel).subscribe(r => {
          if (r.m_Item1) {
            this._notify.success('Uploaded', r.m_Item2);
            this.onPhotoUpload.emit(null);
          } else {
            this._notify.error('Failed', r.m_Item2);
            console.log(r);
          }
        }, err => {
          this._notify.error('Failed', 'Unable to upload photo. Please contact TrackTreads support. ');
          console.log(err);
        });

      } else {
        this._notify.error('Couldn\'t Save', r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.error('Error', 'Failed to save. Please contact TrackTreads support. ');
    });
  }
}



interface FileReaderEventTarget extends EventTarget {
  result: string
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}

